import axios from 'axios';
import ApiURLs from '@/ApiURLs';
 
class ChatService {
    getMessages(data: { roomId: string, reset: boolean, messagesPerPage: number, lastLoadedMessageIndexId: number }) {
        return axios.get(ApiURLs.getMessages, {
            params: {
                roomId: data.roomId,
                reset: data.reset,
                messagesPerPage: data.messagesPerPage,
                lastLoadedMessageIndexId: data.lastLoadedMessageIndexId
            }
        });
    }

    getMessage(data: { messageId: string, roomId: string }) {
        return axios.get(ApiURLs.getMessage, {
            params: {
                messageId: data.messageId,
                roomId: data.roomId
            }
        });
    }

    updateMessages(data: { roomId: string, reset: boolean, messagesPerPage: number, lastLoadedMessageIndexId: number }) {
        return axios.get(ApiURLs.updateMessages, {
            params: {
                roomId: data.roomId,
                reset: data.reset,
                messagesPerPage: data.messagesPerPage,
                lastLoadedMessageIndexId: data.lastLoadedMessageIndexId
            }
        });
    }

    editMessage(data: any) {
        return axios.put(ApiURLs.editMessage, data);
    }

    sendMessage(data: { roomId: string, message: any }) {
        return axios.post(ApiURLs.sendMessage, data.message, { params: { roomId: data.roomId } });
    }

    sendMessageFiles(data: any, config: any) {
        return axios.post(ApiURLs.sendMessageFiles, data, config);
    }

    deleteMessageFiles(data: { roomId: any, messageId: any }) {
        return axios.delete(ApiURLs.deleteMessageFiles, {
            params: {
                roomId: data.roomId,
                messageId: data.messageId
            }
        });
    }

    sendMessageReaction(data: { unicode: symbol, remove: boolean, messageId: number, roomId: string, userId: string }) {
        return axios.put(ApiURLs.sendMessageReaction, null, {
            params: {
                unicode: data.unicode,
                remove: data.remove,
                messageId: data.messageId,
                roomId: data.roomId,
                userId: data.userId,
            }
        });
    }

    createRooms(data: any) {
        return axios.put(ApiURLs.createRooms, null, {
            params: {
                userId: data.userId,
                providerId: data.providerId,
            }
        });
    }

    getRooms(data: {
                    userId: string,
                    isHomeProvider: boolean,
                    providerId: string,
                    roomProviderId: any,
                    roomParentId: any,
                    roomChildId: any,
                    roomsPerPage: number,
                    lastLoadedRoomIndex: number
                }) {
        return axios.get(ApiURLs.getRooms, {
            params: {
                userId: data.userId,
                isHomeProvider: data.isHomeProvider,
                providerId: data.providerId,
                roomProviderId: data.roomProviderId,
                roomParentId: data.roomParentId,
                roomChildId: data.roomChildId,
                roomsPerPage: data.roomsPerPage,
                lastLoadedRoomIndex: data.lastLoadedRoomIndex
            }
        });
    }

    markMessagesSeen(data: { messageIds: string[], roomId: string }) {
        return axios.put(ApiURLs.markMessagesSeen, data.messageIds, {
            params: {
                roomId: data.roomId
            }
        });
    }

    markMessagesRead(data: { messageIds: string[], isHomeProvider: boolean, userOrProviderId: string, roomId: string }) {
        return axios.put(ApiURLs.markMessagesRead, data.messageIds, {
            params: {
                isHomeProvider: data.isHomeProvider,
                userOrProviderId: data.userOrProviderId,
                roomId: data.roomId
            }
        });
    }    
    
    markMessagesDistributed(data: { messageIds: string[], roomId: string }) {
        return axios.put(ApiURLs.markMessagesDistributed, data.messageIds, {
            params: {
                roomId: data.roomId
            }
        });
    }

    setLastRoomMessage(data: { messageId: string, messageIndexId: string, roomId: string }) {
        return axios.put(ApiURLs.setLastRoomMessage, null, {
            params: {
                messageId: data.messageId,
                messageIndexId: data.messageIndexId,
                roomId: data.roomId
            }
        });
    }
}

export default new ChatService();